<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
					<a
						class="br-500-logo"
						href="https://businessrestaurants.nl/restaurants/helling-7-amsterdam/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Officieel opgenomen in de Business Restaurants Top 500. Ons restaurant in Amsterdam is geselecteerd op kwaliteit, service en zakelijke mogelijkheden zoals bedrijfsfeest, private dining, groepslunch, vergaderen en walking dinner."
					>
						<span class="visually-hidden">
							Officieel opgenomen in de Business Restaurants Top 500. Ons restaurant in Amsterdam is
							geselecteerd op kwaliteit, service en zakelijke mogelijkheden zoals bedrijfsfeest, private
							dining, groepslunch, vergaderen en walking dinner.
						</span>
					</a>
				</div>
				<div class="columns column3">
					<h4>{{ $t('address') }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.restaurantName }}</span
						><br />
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
						><br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
						><br />
						<span>{{ defaults[locale].website.country }}</span>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('contact') }}</h4>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<font-awesome-icon class="icon icon-phone" icon="far fa-phone" size="1x" />
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<font-awesome-icon class="icon icon-mail" icon="far fa-envelope" size="1x" />
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('quickLinks') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<p>
						<a
							class="author-link"
							href="https://www.deliciousdomain.com"
							target="_blank"
							rel="noopener noreferrer"
							title="Restaurant webdesign by Delicious Domain"
						>
							<span class="visually-hidden"> Restaurant webdesign by Delicious Domain </span>
							<span
								role="img"
								aria-hidden="true"
								class="author-logo"
								v-html="DeliciousDomainAuthorLogo"
							/>
						</a>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
import DeliciousDomainAuthorLogo from '~/assets/images/author-logo-delicious-domain-currentcolor-except-icon.svg?raw';

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footers {
	color: $footer-color;
	background: $footer-background-color;
	font-size: 18px;

	a {
		color: $footer-color;
		text-decoration: none;
		transition: all 0.3s ease-in-out;

		&:hover {
			color: $cta-color;
		}
	}

	span {
		text-decoration: none;
	}

	h3,
	h4 {
		color: $footer-color;
		letter-spacing: 1px;
	}

	h4 {
		font-size: 1.3em;
	}
}

.visually-hidden {
	position: absolute !important;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip-path: inset(50%);
	white-space: nowrap;
	border: 0;
}

.main-footer {
	padding: 75px 0;
	border-top: 16px solid #091427;

	p {
		font-size: 0.9em;
	}

	a {
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;
		gap: 10px;

		svg {
			color: $cta-color;
		}
	}

	.footer-logo {
		background: url('~/assets/images/logo-helling7-full-white.png') no-repeat center center;
		background-size: 89px;
		width: 89px;
		height: 94px;
		transition: all 0.3s ease-in-out;
	}

	.br-500-logo {
		background: url('~/assets/images/br-500.webp') no-repeat center bottom;
		background-size: 69px;
		width: 69px;
		height: 94px;
		transition: all 0.3s ease-in-out;
	}
}

.author-footer {
	font-size: 0.8em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	p {
		margin: 25px 0;
	}

	.border {
		background: $secondary-background-color;
		width: 100%;
		height: 1px;
	}

	img {
		max-width: 90px;
		margin: -1px 1px 3px 2px;
	}

	.author-link {
		display: inline-flex;
		justify-content: center;
		width: 100%;
		padding: 0;
		transform: translateY(2px);
		margin-bottom: 20px;
	}

	.author-logo {
		display: inline-block;
		line-height: 0;
		max-width: 200px;

		&:hover {
			color: var(--brown);
		}

		:deep(svg) {
			display: block;
			width: 100%;
			height: auto;
		}
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 0 auto 20px;
	}
}

@media (max-width: 640px) {
	.main-footer {
		padding: 30px 5px;
		text-align: center;

		.br-500-logo,
		.footer-logo {
			margin: 20px auto;
		}

		a,
		.socials {
			justify-content: center;
		}
	}
}
</style>
